<template>
    <div class="form-element__container" :id="fullFormIdentifier + '-container'">
        <input :id="fullFormIdentifier" v-model="internalValue" :class="{ 'form-element__input--active': isFilled }"
            class="form-element__input" type="text" :name="inputName" :data-validate="validation"
            :data-validate-message="validationMessage" :data-error-target="fullFormIdentifier + '-container'"
            autocomplete="off" :min="min" :max="max" :step="step" :valid-custom="validCustom"
            v-currency="{ currency: 'GBP', locale: 'en' }" ref="currentInput" />
        <label v-if="showLabel" :for="fullFormIdentifier" class="form-element__label" :class="{ 'form-element__label--active': isFilled }">{{
            inputTitle }}</label>
    </div>
</template>

<script>
import { CurrencyDirective, getValue } from "vue-currency-input";

export default {
    props: {
        value: {
            default: null,
            required: true,
        },
        showLabel: {
            default: true,
            required: false
        },
        formIdentifier: {
            type: String,
            default: "form",
        },
        inputName: {
            type: String,
            default: "",
        },
        inputTitle: {
            type: String,
            required: true,
        },
        inputValidate: {
            type: Boolean,
        },
        inputValidateMessage: {
            type: String,
            default: "",
        },
        min: {
            default: null,
        },
        max: {
            default: null,
        },
        step: {
            default: null,
        },
        integerOnly: {
            default: false,
        },
        validCustom: {
            default: false,
        }
    },
    directives: {
        currency: CurrencyDirective,
    },
    data() {
        return {
            everModified: false,
            internalValue: null,
        };
    },
    created() {
        this.internalValue = this.value;
    },
    watch: {
        internalValue: function (val) {
            let newVal;
            if (typeof val == "string") {
                if (this.$refs.currentInput) {
                    newVal = getValue(this.$refs.currentInput);
                } else {
                    newVal = parseFloat(val);
                }
            }
            if (typeof newVal == "undefined" || newVal === null) {
                newVal = 0;
            }
            if (newVal < 0) {
                newVal = 0;
            }

            this.$emit('input', newVal);
        },
        // value: function (newValue) {
        //     this.internalValue = newValue;
        // }
    },
    computed: {
        isFilled() {
            if (this.internalValue == null) {
                return false;
            }

            if (this.inputType == "number") {
                return !isNaN(this.internalValue);
            }

            if (this.internalValue == '') {
                return false;
            }

            return true;
        },
        validation() {
            if (this.inputValidate) {
                return "input";
            }
            return false;
        },
        validationMessage() {
            if (this.inputValidateMessage) {
                return this.inputValidateMessage;
            }
            return false;
        },
        fullFormIdentifier() {
            return this.formIdentifier + "-" + this._uid;
        },
    },
};
</script>